import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 100px 140px;
  ${legacyTheme.breakpoints.match('md')} {
    padding: 54px 50px 85px 50px;
    flex-direction: column;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex: 1;
`;

const ListContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  div:last-child {
    margin-bottom: 0px;
  }
`;

const ListItem = styled.div`
  margin-bottom: 72px;
  display: flex;
`;

const IconContainer = styled.div`
  margin-right: 88px;
  ${legacyTheme.breakpoints.match('md')} {
    margin-right: 40px;
  }
`;

const StyledTitle = styled(Typography)`
  max-width: 400px;
  ${legacyTheme.breakpoints.match('md')} {
    margin-bottom: 48px;
  }
`;

const StyledDescription = styled(Typography)`
  color: ${theme.colors.neutral[900]};
`;

const StyledItemTitle = styled(Typography)`
  font-size: 16px;
`;

const InformationList = ({ list, title }) => {
  return (
    <Wrapper>
      <TitleContainer>
        <StyledTitle color="noir" markupName="h4" variant="h1">
          {title}
        </StyledTitle>
      </TitleContainer>
      <ListContainer>
        {list.map(({ alt, title: itemTitle, description, icon }) => (
          <ListItem key={itemTitle}>
            <IconContainer>
              <Image alt={alt} height={70} src={icon} width={70} />
            </IconContainer>
            <div>
              <StyledItemTitle bold markupName="h5" variant="mono1">
                {itemTitle}
              </StyledItemTitle>
              <Spacer size={10} />
              <StyledDescription color="noir" variant="p1">
                {description}
              </StyledDescription>
            </div>
          </ListItem>
        ))}
      </ListContainer>
    </Wrapper>
  );
};

InformationList.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      icon: srcOrNextImageProp,
    })
  ).isRequired,
};

export default InformationList;
